import { useMemo } from "react";

import { CommandPaletteBucket } from "../types";
import useCommandPaletteRecentActionsBucket from "./useRecentActionsBucket";
import useCommandPaletteSearchBucket from "./useSearchBucket";
import useCommandPaletteSettingsBucket from "./useSettingsBucket";
import useCommandPaletteNavigationBucket from "./useNavigationBucket";
import useCommandPaletteCreateBucket from "./useCreateBucket";

const useCommandPaletteBuckets = (): CommandPaletteBucket[] => {
  const createBucket = useCommandPaletteCreateBucket();
  const settingsBucket = useCommandPaletteSettingsBucket();
  const searchBucket = useCommandPaletteSearchBucket();
  const navigationBucket = useCommandPaletteNavigationBucket();

  const nonRecentBuckets = useMemo(
    () => [createBucket, settingsBucket, searchBucket, navigationBucket],
    [createBucket, settingsBucket, searchBucket, navigationBucket]
  );

  const recentActionsBucket = useCommandPaletteRecentActionsBucket(nonRecentBuckets);

  return useMemo(
    () => [recentActionsBucket, ...nonRecentBuckets].sort((a, b) => a.order - b.order),
    [recentActionsBucket, nonRecentBuckets]
  );
};

export default useCommandPaletteBuckets;
